import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";

export default function RelatedDramas({ dramas }: { dramas: Drama[] }) {
  if (dramas.length === 0) return null;

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
        <i className="ri-links-line text-primary-500"></i>
        相关推荐
      </h2>
      <ul className="flex flex-col gap-3">
        {dramas.map((drama) => (
          <li key={drama.id}>
            <Link to={`/detail/${drama.id}`} className="group flex cursor-pointer gap-3">
              <div className="h-24 w-[68px] shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={drama.cover}
                  alt={`${drama.title} 封面`}
                  title={`${drama.title} 剧集封面`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {drama.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{drama.synopsis}</p>
                <div className="mt-auto flex items-center gap-2 pt-1 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-600"></i>
                    {drama.rating.toFixed(1)}
                  </span>
                  <span>{drama.categories[0]}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}